// shared/ui/opacidad.js  (valor único para controles deshabilitados: botón "Agregar Imagen", dropzone al llegar al límite)
export const OPACIDAD_DESHABILITADO = 0.4;
